import React, { Reducer } from 'react';
import { IResponseState } from './modules';

type ExtendProperty = 'initialState' | 'url' | 'reducer';
type ExtendValue = Record<string, any> | string | Function;

type IDispatch = (action: IAction) => void;

export interface IModuleStateConfiguration {
  extend: Record<ExtendProperty, ExtendValue>;
  url?: string;
}

export interface IModulesStateConfiguration {
  [key: string]: IModuleStateConfiguration;
}

export interface IStateOptionsConfiguration {
  baseURL: string;
  useAuthorization?: () => string | null;
}

export interface IStateConfiguration {
  modules: IModulesStateConfiguration;
  options: IStateOptionsConfiguration;
}

export interface IState {
  [key: string]: Record<string, any>;
}

export interface IStoreContextValue {
  state: IState;
  dispatch: IDispatch;
  authorization: string | null;
}

export interface IModule {
  initialState: IResponseState<any>;
  reducer: Reducer<any, IAction>;
  useModuleState: Function;
  useModuleStateWithQuery: Function;
  useGetAll: Function;
  useGetById: Function;
  useCreate: Function;
  useUpdate: Function;
  useDelete: Function;
  useRequest: Function;
  useDismissHTTPErrors: Function;
  useResetState: Function;
}

export interface IReactParentPropTypes {
  children?: React.ReactNode;
}

export interface IAction {
  type: string;
  payload?: any;
  query?: Record<string, unknown>;
}

export enum RequestStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export interface IAPIErrorFormat {
  message: string;
  errors: [];
  status: number;
}
